'use es6';

export var SALES = 'sales';
export var SALES_PRO = 'sales-pro';
export var SALES_STARTER = 'sales-starter';
export var SALES_PROFESSIONAL = 'sales-professional';
export var SALES_ENTERPRISE = 'sales-enterprise';
export var MARKETING = 'marketing';
export var MARKETING_STARTER = 'marketing-starter';
export var MARKETING_STARTER_EMAIL = 'marketing-starter-email';
export var MARKETING_BASIC = 'marketing-basic';
export var MARKETING_PRO = 'marketing-pro';
export var MARKETING_ENTERPRISE = 'marketing-enterprise';
export var STARTER_CONTACTS = 'starter-contacts';
export var BASIC_CONTACTS = 'basic-contacts';
export var MARKETING_STARTER_CONTACTS = 'marketing-starter-contacts';
export var MARKETING_PROFESSIONAL_CONTACTS = 'marketing-professional-contacts';
export var MARKETING_ENTERPRISE_CONTACTS = 'marketing-enterprise-contacts';
export var SERVICE = 'service';
export var SERVICE_STARTER = 'service-starter';
export var SERVICE_PROFESSIONAL = 'service-professional';
export var SERVICE_ENTERPRISE = 'service-enterprise';
export var ADS = 'ads';
export var ADS_CAPACITY = 'ads-capacity';
export var WEBSITE = 'website';
export var REPORTING = 'reporting';
export var DEDICATED_IP = 'dedicated-ip';
export var TRANSACTIONAL_EMAIL = 'transactional-email';
export var ADDITIONAL_ACCOUNT = 'additional-account';
export var BRAND_DOMAIN = 'brand-domain';
export var WORKFLOWS_ADDON = 'workflows-addon';
export var LISTS_ADDON = 'lists-addon';
export var CUSTOM_SSL = 'custom-ssl';
export var ESIGNATURES_LIMIT_INCREASE = 'esignatures-limit-increase';
export var DESIGNATED_TECHNICAL_SUPPORT = 'designated-technical-support';
export var IN_PERSON_TRAINING = 'in-person-training';
export var STARTER_KIT = 'starter-kit';
export var SALES_PROFESSIONAL_ONBOARDING = 'sales-professional-onboarding';
export var SERVICE_PROFESSIONAL_ONBOARDING = 'service-professional-onboarding';
export var INBOUND_CONSULTING_BLOCK = 'inbound-consulting-block';
export var TECHNICAL_CONSULTING_BLOCK = 'technical-consulting-block';
export var CMS_ENTERPRISE = 'cms-enterprise';
export var CMS_PROFESSIONAL = 'cms-professional'; // Used only for free product activation

export var CRM = 'crm';
export var SALES_FREE = 'sales-free';
export var MARKETING_FREE = 'marketing-free';
export var SERVICE_FREE = 'service-free'; // Used for partner-program inquiries

export var PARTNER_PROGRAM = 'partner-program'; // For growth-suite purchases

export var SUITE_STARTER = 'suite-starter';
export var SUITE_PROFESSIONAL = 'suite-professional';
export var SUITE_ENTERPRISE = 'suite-enterprise'; // Used when feature can be unlocked by any enterprise SKU

export var ENTERPRISE = 'enterprise';
export var BUNDLE = 'bundle';
export var TEMPORARY_REMOTE_TOOLS = 'temporary-remote-tools'; // Used to designate upgrades not associated with a product
// ONLY FOR USE WITH UIContactSalesButton, see ui-addon-upgrades PR#384

export var GENERAL = 'general';